<!-- @format -->

<ngb-pagination
  data-cy="pagination-component"
  [collectionSize]="totalItems"
  [page]="currentPage"
  (pageChange)="currentPageChange.emit($event)"
  [pageSize]="itemsPerPage"
  [maxSize]="maxSize"
  [ellipses]="true"
  [rotate]="true"
  [disabled]="disabled"
  [attr.aria-label]="'ARIA_LABEL.PAGINATION' | translate">
  <ng-template ngbPaginationPrevious>
    <sis-icon [icon]="'chevron'" [iconClass]="'flip-180'"></sis-icon>
  </ng-template>
  <ng-template ngbPaginationNext>
    <sis-icon [icon]="'chevron'"></sis-icon>
  </ng-template>
</ngb-pagination>
